import type { StyleRule } from '@archipro-design/aria';
import {
    captionClassName,
    HeaderClassName,
    pxArrayToRem,
    pxToRem,
} from '@archipro-design/aria';

export const PAGE_HEADER_HEIGHT_EXPANDED = 235;

export const TitleContainer: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([16, 18, 16, 18]),
    [theme.screen.laptop]: {
        position: 'relative',
        padding: 0,
        display: 'flex',
        width: '100%',
        alignItems: 'flex-start',
        flexDirection: 'column',

        marginTop: pxToRem(32),
        marginBottom: pxToRem(24),
    },
});

export const Header: StyleRule<{ isSticky: boolean }> = ({
    theme,
    isSticky,
}) => ({
    marginTop: 0,
    marginBottom: 0,

    [`&.${HeaderClassName}`]: {
        fontSize: pxToRem(20),
        lineHeight: theme.siteVariables.lineHeightDefault,
        letterSpacing: theme.siteVariables.letterSpacingMedium,
    },
    ...theme.siteVariables.textStyles.Text.Roman55,
    [theme.screen.laptop]: {
        paddingRight: isSticky ? 0 : '25%',
        [`&.${HeaderClassName}`]: {
            fontSize: isSticky ? pxToRem(22) : pxToRem(80),
            marginBottom: isSticky ? pxToRem(8) : pxToRem(24),
            lineHeight: '1.1',
            letterSpacing: isSticky
                ? theme.siteVariables.letterSpacingMedium
                : pxToRem(-2.4),
        },
    },
});

export const SubHeader: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.grey['300'],
    marginTop: 0,
    marginBottom: pxToRem(6),
    [`&.${HeaderClassName}`]: {
        fontSize: theme.siteVariables.fontSizes['label02'],
        letterSpacing: theme.siteVariables.letterSpacingNormal,
        lineHeight: '130%',
    },
    ...theme.siteVariables.textStyles.Text.Roman55,
});

export const HeaderProfessionalLink: StyleRule = ({ theme }) => ({
    textUnderlineOffset: pxToRem(2),
    marginTop: pxToRem(6),
    color: theme.siteVariables.colors.charcoal['100'],
    display: 'inline-block',
    ...theme.siteVariables.textStyles.Text.Roman55,
    [`& a.${captionClassName}`]: {
        textDecoration: 'underline !important',
    },
    [theme.screen.tablet]: {
        marginTop: 0,
        display: 'inline',
        color: theme.siteVariables.colors.charcoal['300'],
        fontSize: pxToRem(20),
        lineHeight: '1.1',
    },
});

export const HeaderCTA: StyleRule<{ isSticky: boolean }> = ({ isSticky }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: isSticky ? 'center' : 'flex-end',
});

export const TopPaneContainer: StyleRule = () => ({
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 'auto',
    paddingTop: pxToRem(6),
});

export const LinkButton: StyleRule = () => ({
    textDecoration: 'underline',
    '& > span': {
        marginRight: pxToRem(10),
    },
});

export const ProductHeaderContainer: StyleRule<{ isSticky: boolean }> = ({
    theme,
    isSticky,
}) => ({
    [theme.screen.laptop]: {
        position: isSticky ? 'sticky' : 'relative',
        zIndex: theme.siteVariables.zIndexes.foreground + 1,
        top: 0,
        margin: pxArrayToRem([0, -50]),
        transform: 'translateZ(0)',
        willChange: 'transform',

        [`& > div`]: {
            boxShadow: isSticky
                ? '0px 2px 24px 0px rgba(0, 0, 0, 0.10)'
                : 'none',
            transition: 'box-shadow 0.2s ease-in-out',
            background: theme.siteVariables.colorScheme.default?.background,
        },
    },
});

export const PageHeader: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        padding: pxArrayToRem([0, 50]),
        background: theme.siteVariables.colorScheme.default?.background,
        display: 'flex',
        alignItems: 'start',
        flexDirection: 'column',
    },
});
